import functions from '../functions';

$(function () {
    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                constrols: true,
                dynamic: true,
                thumbnail: functions.isMobile() ? false : true,
                thumbnail: functions.isMobile() ? false : true,
                toogleThumb: true,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                fullScreen : true,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id)),
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });

    // Native Gutenberg gallery (core/gallery). The block markup is just <img>s
    // rendered at a small size (e.g. 160x90) with lozad owning data-src, so we
    // can't feed lightGallery off the DOM attrs. Build a dynamic slide list
    // instead: full image from the biggest srcset entry (falling back to a
    // wrapping <a> href / Gutenberg's data-full-url / the visible src), and a
    // proper thumb from the smallest.
    const pickFromSrcset = (img, largest) => {
        const set = (img.getAttribute('srcset') || '').split(',').map(s => s.trim()).filter(Boolean);
        let best = null;
        set.forEach(entry => {
            const parts = entry.split(/\s+/);
            const w = parseInt(parts[1], 10) || 0;
            if ( ! best || ( largest ? w > best.w : w < best.w ) ) {
                best = { w: w, url: parts[0] };
            }
        });
        return best && best.url;
    };

    $('.wp-block-gallery').each(function () {
        const imgs = $(this).find('img').toArray();
        if ( ! imgs.length ) {
            return;
        }

        const dynamicEl = imgs.map(img => {
            const href = $(img).closest('a').attr('href') || '';
            return {
                src:
                    ( /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(href) && href ) ||
                    pickFromSrcset(img, true) ||
                    img.dataset.fullUrl ||
                    img.currentSrc || img.src,
                thumb: pickFromSrcset(img, false) || img.currentSrc || img.src,
            };
        });

        const $gallery = $(this);
        let inst = null;

        $gallery.on('click', 'img', function () {
            const index = imgs.indexOf(this);
            if ( inst ) {
                inst.index = index;
                inst.build(index);
                return;
            }
            inst = $gallery.lightGallery({
                dynamic: true,
                dynamicEl: dynamicEl,
                thumbnail: ! functions.isMobile(),
                toogleThumb: true,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                fullScreen: true,
                preload: 2,
                index: index,
            }).data('lightGallery');
        });
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });
    /* end gallery */
});